import { FC } from 'react';
import { useIsMobile } from '../../../../../utils/getIsMobile';
import { useTranslation } from '../../../../../utils/useTranslation';
import { Typography } from '../../../../typography/Typography';
import { BookmarkStep } from '../../types';
import { TitleContentProps } from './types';

export const TitleContent: FC<TitleContentProps> = ({ step }) => {
    const t = useTranslation();
    const isMobile = useIsMobile();

    if (step === BookmarkStep.ADD_TO_EXIST_COLLECTION) {
        return (
            <>
                <Typography variant="title3" weight="bold" mr="auto">
                    {t('Пост сохранён')}
                </Typography>
            </>
        );
    }

    if (step === BookmarkStep.ADD_TO_NEW_COLLECTION) {
        return (
            <Typography
                variant={isMobile ? 'body' : 'title3'}
                weight="bold"
                mr="auto"
                ml={{ xs: 'auto', md: 0 }}
                py={{ md: 0 }}
            >
                {t('Новая коллекция')}
            </Typography>
        );
    }

    return null;
};
